import TicketFirstStep from "../components/TicketFirstStep";

import { useMediaQuery } from "@mui/material";
import { FC, useReducer } from "react";
import { useSelector } from "react-redux";
import { Modal } from "ui";

import Basket from "../components/Basket/Basket";
import {
    BasketContext,
    BasketDispatchContext,
    initState,
} from "../components/Basket/basketContext";
import basketReducer from "../components/Basket/basketReducer";

interface ITicketsModal {
    onCloseModal: () => void;
    onCloseEventDetails: () => void;
    uuid: string;
}

const TicketModal: FC<ITicketsModal> = ({
    onCloseModal,
    onCloseEventDetails,
    uuid,
}) => {
    const { "general-max_tickets": maxTickets } = useSelector(
        (state: any) => state.web.settings.location_settings,
    );

    const [basket, dispatch] = useReducer(basketReducer, {
        ...initState,
        maxTickets,
        uuid,
    });

    const smallScreen = useMediaQuery((theme: any) =>
        theme.breakpoints.down("tablet"),
    );

    const handleClose = () => {
        onCloseModal();

        if (onCloseEventDetails) {
            onCloseEventDetails();
        }
    };

    const renderView = () => {
        return basket.event ? (
            <Basket onClose={handleClose} uuid={uuid} />
        ) : (
            <TicketFirstStep onClose={handleClose} />
        );
    };

    return (
        <Modal
            maxWidth="md"
            fullWidth
            open
            fullScreen={smallScreen}
            scroll="paper"
            {...(!smallScreen && {
                sx: {
                    ".MuiDialog-container": {
                        justifyContent: "flex-end",
                    },
                    ".MuiPaper-root": {
                        margin: "0",
                        width: 630,
                        height: "100%",
                        maxHeight: "100%",
                        borderRadius: 0,
                    },
                },
            })}
        >
            <BasketContext.Provider value={basket}>
                <BasketDispatchContext.Provider value={dispatch}>
                    {renderView()}
                </BasketDispatchContext.Provider>
            </BasketContext.Provider>
        </Modal>
    );
};

export default TicketModal;
